import { EditRowDecorator, Layout } from "@mcleod/components";
import { LateRouteView } from "./LateRouteView";
import { EditRowDecoratorProps } from "@mcleod/components/src/page/decorators/EditRowDecoratorProps";

interface LateRouteViewSlideoutProps {
    movementId: string;
    stopId: string;
    isCurrent?: boolean;
}

export class LateRouteViewSlideout {
    constructor(props: LateRouteViewSlideoutProps, sldProps?: Partial<EditRowDecoratorProps>) {
        this.slideUp(props);
    }

    slideUp(props: LateRouteViewSlideoutProps, sldProps?: Partial<EditRowDecoratorProps>) {
        const { movementId, stopId, isCurrent } = props;
        const layout = Layout.getLayout("lme/dispatch/asset/LateRouteView") as LateRouteView;
        const slideout = new EditRowDecorator({
            layout: layout,
            title: "Late Route View",
            width: "80%",
            dataSource: layout.mainDataSource,
            fillVerticalSpace: true,
            overlayProps: { greyedBackground: true },
            onClose: () => slideout.slideOut(),
            layoutLoadListeners: async () => {
                await layout.mainDataSource.search({
                    movement_id: movementId,
                    ...(isCurrent ? { is_current: "Y" } : { next_stop_id: stopId })
                }).then(() => {
                    if (layout.activeRow) {
                        layout.sourceComments.search({ parent_row_id: layout.activeRow.get("next_stop.id") });
                    }
                });
                await layout.sourceLateRouteHistory.search({ movement_id: movementId });
                if (layout.activeRow)
                    layout.tableLateRouteHistory.selectedRow = layout.tableLateRouteHistory.rows.find(r => r.data.get("id") === layout.activeRow.get("id"));
            },
            onSave: (updatedData) => {
                if (layout.mainDataSource.hasChanged(true)) {
                    layout.mainDataSource.post();
                }
            },
            ...props
        });
    }
}
